module.exports = __webpack_public_path__ + "static/logo-carrefour-7db19ef3f5b15212b6bad055ebd6418e.svg";